export default __webpack_public_path__ + "static/media/rotate_icon.646850e9.svg";